// @ts-ignore
import { useTranslation } from "react-i18next";
import Select from "react-select";

import _ from "lodash";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Row } from "components/ui-kit/styled-templates";

import QuestionnairesApi from "api/questionnaires-api";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals } from "types/enums";

const EditQuestionnaireModal = () => {
    const { t } = useTranslation();

    const {
        data: formData,
        onSubmit,
        clearForm,
        setValues
    } = useFormControl({
        name: EForms.editQuestionnaire,
        schema: Schemas[EForms.editQuestionnaire]
    });
    const { close, state: modalState = {} } = useModal(EModals.CreateQuestionnaire, {
        onOpen: ({ data = {} }: any) => setValues(data?.details ?? {})
    });
    const { mode, data } = modalState;

    const anyChanges = !_.isEqual(data?.details, formData);

    const handlers = {
        submit: async (details: any) => {
            if (mode === `create`) {
                await QuestionnairesApi.createQuestionnaire(details);
            } else {
                await QuestionnairesApi.updateQuestionnaire({ ...data, details });
            }
            close();
        }
    };
    return (
        <PopUpWrapper name={EModals.CreateQuestionnaire} onClose={clearForm}>
            <Form name={EForms.editQuestionnaire} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{mode === `edit` ? `Редактирование опросника` : `Добавить опросник`}</h3>

                <Control.Row>
                    <Control.Input name="name" label={t("eyju7a2b34b")} placeholder="" isRequired />
                </Control.Row>

                <Control.Row>
                    <Control.Textarea name="question" label={t("m2bxywqc8x")} placeholder="" isRequired />
                </Control.Row>

                <Control.Row>
                    <Control.Select
                        name="role"
                        placeholder={"Для кого"}
                        label={"Для кого"}
                        options={[
                            { value: "user", label: "Путешественник" },
                            { value: "uni-admin", label: "ВУЗ" }
                        ]}
                    />
                </Control.Row>


                {/*<div style={{ marginBottom: 20 }}>*/}
                {/*    <Select*/}
                {/*        placeholder={"Для кого"}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                value: "user",*/}
                {/*                label: "Для путешественников"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                value: "uni-admin",*/}
                {/*                label: "Для ВУЗов"*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<Control.Row>*/}
                {/*    <Control.Radio*/}
                {/*        label={'Для путешественников'}*/}
                {/*        checked={_.get(data, `forWhom`) === 'user'}*/}
                {/*        onChange={(e) => {*/}

                {/*        }}*/}
                {/*    />*/}
                {/*    <Control.Radio*/}
                {/*        label={'Для ВУЗов'}*/}
                {/*        checked={_.get(data, `forWhom`) === 'uni-admin'}*/}
                {/*        onChange={e => {*/}

                {/*        }}*/}
                {/*    />*/}
                {/*</Control.Row>*/}

                {anyChanges && <Control.Error extra={`margin-bottom: 15px;`}>{t("8egvaca23gy")}</Control.Error>}
                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("3rqccmzrcny")}
                    </Button>
                    <Button type="submit" background="green">
                        {t("ho9iinhvkee")}
                    </Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditQuestionnaireModal;
